export const fetchSummary = async (
  jobDescription: string,
  adType: string,
  positionTitle: string,
  customDescription: string,
  tone: string,
  signal: AbortSignal,
  feedbackInput?: string
) => {
  const res = await fetch('/api/v4/ai_studio', {
    signal: signal,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ai_studio: {
        type: 'advertisement',
        job_description: jobDescription,
        ad_type: adType,
        job_details: { position_title: positionTitle },
        use_custom_description: customDescription,
        tone: tone,
        ...(feedbackInput && { feedback: feedbackInput })
      }
    })
  });
  return (await res.json()) as { result: string };
};

export const fetchKeyPoints = async (jobDescription: string, positionTitle: string) => {
  const res = await fetch('/api/v4/ai_studio', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ai_studio: {
        type: 'keypoints',
        job_description: jobDescription,
        job_details: { position_title: positionTitle }
      }
    })
  });
  return (await res.json()) as { result: string };
};

export const fetchSocial = async (
  jobDescription: string,
  positionTitle: string,
  customDescription: string,
  includeHashtags: boolean,
  tone: string,
  length: string,
  signal: AbortSignal,
  feedbackInput?: string
) => {
  const res = await fetch('/api/v4/ai_studio', {
    signal: signal,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ai_studio: {
        type: 'social',
        job_description: jobDescription,
        job_details: { position_title: positionTitle },
        use_custom_description: customDescription,
        include_hashtags: includeHashtags,
        tone: tone,
        summary_length: length,
        ...(feedbackInput && { feedback: feedbackInput })
      }
    })
  });
  return (await res.json()) as { result: string };
};
